import { Store } from 'src/store/index';

const getEditorScenes = (store: Store, productUid: string, bundledProductId: number) => store.editor.editorScenes[`${productUid}_${bundledProductId}`]?.scenes;

export default getEditorScenes;
